(function(angular){
	'use strict';
	
	angular
		.module('investorDashboard')
		.directive('earningsToDateChart', [
			'$http',
			'HIGHCHARTS_OPTIONS',
			earningsToDateChart
		]);
	
	function earningsToDateChart(
		$http,
		HIGHCHARTS_OPTIONS
	){
		return {
			replace: true,
			restrict: 'E',
			template: '<div class="module-section" style="border-top: none;"><div id="js-dividend-returns-chart" style="width:100%; height:350px;"></div></div>',
			scope: {
				endpointUrl: '@',
				individualReitPage: '='
			},
			link: function($scope, $elem, $attrs){
				var chart;
				
				function createDividendReturnsChart(data, plotLines, mostRecentPaidDividend){
					var chartOptions = {
						chart: {
							renderTo: 'js-dividend-returns-chart',
							type: "area"
						},
						xAxis: {
							type: "datetime",
							tickInterval: 30 * 24 * 3600 * 1000,
							plotLines: plotLines,
							lineColor : 'hsl(210,10%,85%)',
							tickColor : 'hsl(210,10%,85%)',
							gridLineColor : 'hsl(210,10%,85%)',
							labels: {
								style: {
									color: 'hsl(210,10%,55%)'
								}
							}
						},
						yAxis: {
							lineColor : 'hsl(210,10%,85%)',
							tickColor : 'hsl(210,10%,85%)',
							gridLineColor : 'hsl(210,10%,85%)',
							labels: {
								formatter: function () {
									return accounting.formatMoney(this.value, "$", 0);
								},
								style: {
									color: 'hsl(210,10%,55%)'
								}
							},
							title: {
								text: null
							}
						},
						tooltip: {
							enabled: true,
							useHTML: true,
							formatter: function() {
								return   Highcharts.dateFormat(' %B %e, %Y', new Date(this.x)) +
									'<br><span style="color:' + this.series.color + '">\u25CF</span><b> ' + this.series.name +':</b> ' + accounting.formatMoney(this.y, "$", 2) + "<br>";
							}
						},
						plotOptions: {
							area: {
								stacking: "normal",
								lineWidth: 2,
								marker: {
									symbol: "circle",
									radius: 4,
									enabled: false,
									states: {
										hover: {
											enabled: true
										}
									}
								},
								fillOpacity: 0.25
							}
						},
						series: data
					};

					chartOptions = angular.extend(HIGHCHARTS_OPTIONS(), chartOptions);

					chart = new Highcharts.Chart(chartOptions, function(chart){
						if (mostRecentPaidDividend) {
							for (var i = 0; i < chart.series.length; i++){
								var paidDividendIndex = false;
								var lastUnpaidEarning = chart.series[i].points.length - 1;
								var chartSeriesData = chart.series[i].points;
	
								for (var j = 0; j < chartSeriesData.length; j++){
									if (chartSeriesData[j].x === mostRecentPaidDividend) {
										paidDividendIndex = j;
										break;
									}
								}
	
								if (paidDividendIndex){
									chart.series[i].points[paidDividendIndex].update({
										marker: {
											enabled: true
										}
									});
								}
	
								chart.series[i].points[lastUnpaidEarning].update({
									marker: {
										enabled: true
									}
								});
							}
						}
					});
				}
	
				function generatePlotLines(mostRecentPaidDividend, currentDate){
					var plotLines = [
						{
							color: "#c7ccd1",
							width: 1,
							label: {
								text: "Paid earnings",
								rotation: 0,
								align: "right",
								x: -10,
								y: 50,
								style: {
									color: "#55595e",
									fontSize: "16px"
								}
							},
							zIndex: 3,
							value: mostRecentPaidDividend
						}, {
							color: "#c7ccd1",
							width: 1,
							label: {
								text: "Unpaid earnings",
								rotation: 0,
								align: "right",
								x: -10,
								y: 20,
								style: {
									color: "#55595e",
									fontSize: "16px"
								}
							},
							zIndex: 3,
							value: currentDate
						}
					];
	
					return plotLines;
				}
				
				function generateSeriesData(dividendData, mostRecentPaidDividend){
					var seriesData = [];
	
					for (var i=0; i<dividendData.length; i++) {
						var earnedDividendsData = [];
	
						for (var j=0; j<dividendData[i].earnedDividends.length; j++) {
							var date = dividendData[i].earnedDividends[j].date;
							var netAccountValue = dividendData[i].earnedDividends[j].netAccountValue;
							
							earnedDividendsData.push([date, netAccountValue]);
						}
						
						var series = {
							name: dividendData[i].investmentName,
							color: dividendData[i].color,
							data: earnedDividendsData,
							zoneAxis: "x",
							fillColor: {
								linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
								stops: [
									[0, Highcharts.Color(dividendData[i].color).setOpacity(0.5).get('rgba')],
									[1, Highcharts.Color(dividendData[i].color).setOpacity(0).get('rgba')]
								]
							},
							zones: [{
								value: mostRecentPaidDividend === undefined ? dividendData[i].earnedDividends[0].date : mostRecentPaidDividend
							}, {
								dashStyle: "dash",
								fillColor: {
									linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
									stops: [
										[0, Highcharts.Color(dividendData[i].color).setOpacity(0.25).get('rgba')],
										[1, Highcharts.Color(dividendData[i].color).setOpacity(0).get('rgba')]
									]
								}
							}]
						};
	
						seriesData.push(series);
					}
					
					return seriesData;
				}
				
				$http.get($scope.endpointUrl).then(function(response){
					var dividendData = response.data.dividendChartElements;
					
					var currentDate = dividendData[0].earnedDividends[dividendData[0].earnedDividends.length - 1].date;
					var mostRecentPaidDividend = response.data.mostRecentPaidDividend !== undefined ? response.data.mostRecentPaidDividend : false;
	
					var seriesData = generateSeriesData(dividendData, mostRecentPaidDividend);
					var plotLines = response.data.mostRecentPaidDividend !== undefined ? generatePlotLines(mostRecentPaidDividend, currentDate) : false;
					
					createDividendReturnsChart(seriesData, plotLines, mostRecentPaidDividend);
				});
			}
		};
	}
})(window.angular);

